import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { finalize, map } from 'rxjs';
import { StatusuriProiecteService } from '../../../setari-proiecte/statusuri-proiecte/statusuri-proiecte.service';
import { initializeEditor } from 'src/app/utils/editorConfig';
import { helper } from 'src/environments/helper';
import { Generic } from 'src/app/interfaces/generic.interface';
import { NotificationService } from 'src/app/services/notification.service';
import { EditProiectStatusPayload } from './actualizare-proiect.interface';
import { ProiecteService } from '../../proiecte.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { notDefaultValidator } from 'src/app/validators/not-default';

@Component({
    selector: 'app-actualizare-proiect',
    templateUrl: './actualizare-proiect.component.html',
    styleUrls: ['./actualizare-proiect.component.scss']
})
export class ActualizareProiectComponent implements OnInit, OnChanges {
    @Input() proiect!: any;
    @Output() proiectChanged: EventEmitter<void> = new EventEmitter();

    passedProiectId!: number;

    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;

    editorConfig!: AngularEditorConfig;
    isLoading = false;
    selectedActionToggle = 'status';

    proiectStatuses: Generic[] = [];

    sendUpdateStatusForm!: FormGroup;

    defaultChoiceParameter: { name: string; id: string } = {
        name: '-- Alegeți --',
        id: '-1',
    };

    constructor(
        private proiectStatusService: StatusuriProiecteService,
        private fb: FormBuilder,
        private notificationService: NotificationService,
        private proiecteService: ProiecteService,
        public permissionsService: PermissionsService,
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        this.passedProiectId = this.proiect.id_proiect;
    }

    ngOnInit(): void {
        this.editorConfig = initializeEditor();
        this.loadProiectStatuses();

        this.sendUpdateStatusForm = this.fb.group({
            status: new FormControl('-1', notDefaultValidator('-1')),
            description: new FormControl(''),
        })
    }

    loadProiectStatuses() {
        this.proiectStatusService
            .getStatusuriAllActive()
            .pipe(map((res: any) => [this.defaultChoiceParameter, ...res]))
            .subscribe((data: any) => {
                this.proiectStatuses = data;
            })
    }

    onActionChange(event: MatButtonToggleChange) {
        this.selectedActionToggle = event.value;
    }

    submitUpdateStatusMessage() {
        this.isLoading = true;

        const formValues = this.sendUpdateStatusForm.value;

        const newProiectStatus: EditProiectStatusPayload = {
            ...formValues,
        }

        this.proiecteService
            .updateProiectStatus(this.proiect.id_proiect, newProiectStatus)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.isLoading = false;
                    this.notificationService.warningSwal(
                        this.successTitle,
                        'Proiect actualizat cu succes!',
                        this.successIcon
                    ).then(() => {
                        this.proiectChanged.emit();
                        this.sendUpdateStatusForm.patchValue({
                            status: this.sendUpdateStatusForm.get('status')?.value,
                            description: '',
                        });
                    });
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(this.errorTitle, msg, this.errorIcon);
                }
            })
    }
}
